import { render } from "./PickDayReport.vue?vue&type=template&id=94aa4594"
import script from "./PickDayReport.vue?vue&type=script&lang=ts"
export * from "./PickDayReport.vue?vue&type=script&lang=ts"
script.render = render

export default script